<template>

    <div class="topbar">

        <nav class="topbar__menu" v-if="isAuth()">

            <a class="topbar__menu__item"
                :href="myAccountLink()">
                <i class="icon-user"></i>
                <span>{{ myAccountName() }} ({{ myAccountProfil() }})</span>
			</a>

            <a class="topbar__menu__item"
                :href="logoutLink()">
                <i class="icon-logout"></i>
                <span>Se déconnecter</span>
			</a>

        </nav>

        <nav class="topbar__menu" v-if="!isAuth()">

            <a class="topbar__menu__item"
                href="#"
                v-on:click.stop="showAuthModal()">                
                <i class="icon-user"></i>
                <span class="topbar-title">Espace mon compte</span>
            </a>

        </nav>


        <div class="modale" :class="{'visible': authModalOpened}" v-if="!isAuth()">
            <dialog class="dialog dialog--login2">

                <div class="dialog__heading">

                    <h3 class="dialog-title">Se connecter</h3>

                    <button class="dialog__heading__close"
                        type="button"
                        v-on:click="hideAuthModal()">
                        <i class="icon-cancel"></i>
                    </button>
                </div>

                <div class="dialog__body">
                    <div class="woocommerce">
                        <form class="woocommerce-form woocommerce-form-login" method="post" :action="loginLink()">
                
                            <p class="woocommerce-form-row woocommerce-form-row--wide form-row form-row-wide">
                                <label for="username">Utilisateur ou adresse e-mail&nbsp;<span class="required">*</span></label>
                                <input type="text" class="woocommerce-Input woocommerce-Input--text input-text" name="username" id="username" autocomplete="username" value="">			</p>
                            <p class="woocommerce-form-row woocommerce-form-row--wide form-row form-row-wide">
                                <label for="password">Mot de passe&nbsp;<span class="required">*</span></label>
                                <span class="password-input"><input class="woocommerce-Input woocommerce-Input--text input-text" type="password" name="password" id="password" autocomplete="current-password"><span class="show-password-input"></span></span>
                            </p>
                            
                            <p class="form-row">
                                <label class="woocommerce-form__label woocommerce-form__label-for-checkbox woocommerce-form-login__rememberme">
                                    <input class="woocommerce-form__input woocommerce-form__input-checkbox" name="rememberme" type="checkbox" id="rememberme" value="forever"> <span>Se souvenir de moi</span>
                                </label>
                                <input type="hidden"
                                    name="_wp_http_referer"
                                    :value="loginReferer()">
                                <button type="submit" class="button_  color small" name="login" value="Log in">Se connecter</button>
                            </p>

                            <p class="woocommerce-LostPassword lost_password">
                                <a href="/my-account/lost-password/">Mot de passe oublié?</a>
                            </p>
                            
                        </form>
                    </div>               
                </div>

            </dialog>
        </div>        

    </div>


    

</template>


<script>

import { mapState } from 'vuex'

export default {

    data() {
        return {
            authModalOpened: false
        }
    },

   computed: mapState({

        /*myAccountLink: () => window.__ACCOUNT_URL__
        utilisateur: () => window.__CURRENT_LOGIN,
        isAuth: () => window.__IS_LOGIN__,
        loginLink: () => window.__LOGIN_URL__.replace('&amp;', '&'),
        loginReferer: () => window.__LOGIN_REFERER__
        loginNonce: () => window.__LOGIN_NONCE__        */

    }),

    methods: {

        isAuth: function() {
            return window.__IS_LOGIN__;
        },

        myAccountLink: function() {
            return window.__ACCOUNT_URL__;
        },

        myAccountName: function() {
            return window.__CURRENT_LOGIN__;
        },

        myAccountProfil: function() {
            return window.__CURRENT_PROFIL__;
        },

        loginReferer: function() {
            return window.__LOGIN_REFERER__;
        },

        loginLink: function() {
            return window.__LOGIN_URL__.replace('&amp;', '&');
        },

        logoutLink: function() {
            return window.__LOGOUT_URL__ ? window.__LOGOUT_URL__.replace('&amp;', '&') : null
        },

        showAuthModal: function() {
            this.authModalOpened  = true
        },

        hideAuthModal: function() {
            this.authModalOpened  = false
        }

    },

    created() {

    },

    name: 'Modale'
}
</script>

<style>

dialog {
    display: block;
    border: none;
    padding: 0;
}

.dialog-title {
    margin: 0;
    padding: 0;
}

.modale {

    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 99998;

    display: flex;
    align-items: center;
    height: 100vh;
    width: 100%;
    overflow-y: auto;

    background-color: rgba(255, 255, 255, 0.54);       
}

.modale:not(.visible) {
    opacity: 0;
    top: -100vh;
}

.dialog {
    display: flex;
    flex-direction: column;
    background-color: rgb(255, 255, 255);
    box-shadow: 0px 2rem 6rem rgba(0, 0, 0, 0.46);
    margin: 0 auto;
    max-width: 90%;    
}

.dialog.dialog--login {
    min-width: 25rem;
}

.dialog .dialog__heading {
    position: relative;
    padding: 1rem 5rem;
    background-color: rgb(242, 244, 245);
    text-align: center;
}

.dialog .dialog__heading .dialog__heading__close {
    position: absolute;
    z-index: 99999;
    top: 50%;
    right: 2rem;
    transform: translateY(-50%);

    font-size: 200%;
    border: 0 none;
    background: 0 0;
    cursor: pointer;
}

.dialog .dialog__body {
    padding: 2rem 2rem;
    text-align: left;
}

.dialog .dialog__body form {
    margin: 0;
}

.dialog .dialog__body .dialog__body__actions {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 2rem;
}

.dialog .dialog__body .dialog__body__actions > * {
    margin: 0;
    width: 100%;
}

.dialog .dialog__body .dialog__body__actions > :not(:last-child) {
    margin-right: 1rem;
    margin-bottom: 1rem;
}

@media screen and (min-width: 800px) {

    .dialog {
        min-height: auto;
        max-width: 90%;    
    }

    .dialog .dialog__body .dialog__body__actions {
        flex-direction: row;
    }

    .dialog .dialog__body .dialog__body__actions > * {
        width: auto;
    }

    .dialog .dialog__body .dialog__body__actions > :not(:last-child) {
        margin-bottom: 0;
    }
}

.topbar {
    font-family: "Source Sans Pro";
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    height: 5rem;
 /*   background-color: rgb(255, 255, 255);*/
}

.topbar .topbar__menu {    
    display: flex;
    flex-direction: row;
    height: 100%;
    align-items: center;
}

.topbar .topbar__menu .topbar__menu__item,
.topbar .topbar__menu .topbar__menu__item:hover,
.topbar .topbar__menu .topbar__menu__item:active {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 100%;
    padding: 0 1.5rem;

    color: rgb(75, 75, 75);
    font-weight: bold;
    text-decoration: none;
    text-transform: uppercase;
}

.topbar .topbar__menu .topbar__menu__item:hover {
    background-color: rgb(235, 235, 235);
}

.topbar .topbar__menu .topbar__menu__item > i {
    color: rgba(75, 75, 75, 0.7);
    margin-right: 0.5rem;
}

.topbar .topbar__menu .topbar__menu__item.topbar__menu__item--location .topbar-title {
    display: none;
}

@media screen and (min-width: 800px) {
    
    .topbar .topbar__menu .topbar__menu__item.topbar__menu__item--location .topbar-title {
        display: inline;
    }
}

</style>
